import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { Site } from 'models/site';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-country-switcher',
    templateUrl: './country-switcher.component.html',
    styleUrls: ['./country-switcher.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CountrySwitcherComponent implements OnInit {
    @Input() pageType: string;
    @Output()
    url: EventEmitter<string> = new EventEmitter<string>();

    public _$sites: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);
    public flagPath: string = 'en';
    public site: Site = null;
    public selectedValue: string;

    constructor(public config: ConfigurationService) {}

    public get sites$(): Observable<{}> {
        return this._$sites.asObservable();
    }

    ngOnInit() {
        this.getSites();
        this.site = this.config.getSiteFromUrl();
        if (this.site) {
            this.selectedValue = this.site.site;
        }
    }

    getSites() {
        if (this.config.$globalSettings) {
            this.config.$globalSettings.subscribe((settings) => {
                const sites = settings.filter((site) => site.enabled === true && site[this.pageType]);

                this._$sites.next(sites);
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.getSites();
    }

    onSelect(url) {
        this.url.emit(url);
    }
}
